import Vue from 'vue'
import {serverBus} from '../main'

const axios = require('axios')
export const loadSettings = {
  methods: {
    async loadSettings () {
      let ask = this.ask
      return axios
        .post(this.ask.url + '/api/ask/get-setting', {ask})
        .then(response => {
          Vue.prototype.$settings = this.settings = response.data.data
          let data = JSON.parse(localStorage.getItem('dataHistory'))
          // let data = JSON.parse(localStorage.getItem('dataHistory'))
          // unic start process after reload from ls
          if (data) {
            if (data.body.lang === this.ask.lang) {
              if (this.$settings) {
                serverBus.$emit('openingWidget')
                serverBus.$emit('openCategories')
              }
            } else {
              localStorage.removeItem('dataTotalAnswers')
              localStorage.removeItem('dataTotalCategory')
              localStorage.removeItem('dataHistory')
            }
          }
        })
        .catch(e => {
          let webimButton = document.getElementsByClassName('webim-button-slider webim_button')
          if (webimButton && webimButton[0]) {
            webimButton[0].style.cssText += 'display:inline!important;'
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/loadSettings.js